import React, { useEffect, useState, useContext, useRef } from "react";
import styles from "./Checkout.module.css";
import { BiSolidLock } from "react-icons/bi";
import axiosPrivate from "../../../hooks/axiosPrivate";
import { useNavigate } from "react-router";
import UserAddressForm from "../userDashboard/manageAddresses/userAddressesForm";
import { Dialog } from "primereact/dialog";
import { errorToast, successToast } from "../../backend/common/Toaster";
import { showErrorToast } from "../../../Toster";
import { FaAngleRight, FaAngleDown } from "react-icons/fa6";
import LoaderContext from "../../../context/Loader/LoaderContext";
import CartCountContext from "../../../context/CartCount/CartCountContext";
function Checkout({ product }) {
  const navigate = useNavigate();
  const { setLoaderCheck } = useContext(LoaderContext);
  const [addresses, setAddresses] = useState([]);
  const [checkoutProduct, setCheckoutProduct] = useState([]);
  const [checkoutTotal, setCheckoutTotal] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [couponList, setCouponList] = useState([]);
  const [showPaymentMethod, setPaymentMethod] = useState("Online");
  const [errorMsg, setErrorMsg] = useState("");
  const [differentAddress, setDifferentAddress] = useState(false);
  const [userLogin, setUserLogin] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );
  const { setCartCount } = useContext(CartCountContext);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [visible, setVisible] = useState(false);
  const [shippingDelivery, setShippingDelivery] = useState({});
  const [userData, setUserData] = useState({});
  const [couponValue, setCouponValue] = useState(null);
  const [inputCouponValue, setInputCouponValue] = useState(null);
  const [couponName, setCouponName] = useState("");
  const [seletedCouponId, setSelectedCouponId] = useState("");
  const [discountValue, setDiscountValue] = useState(null);
  const [removeCoupon, setRemoveCoupon] = useState(false);

  const [billingAddress, setBillingAddress] = useState({});
  const [newAddress, setNewAddress] = useState(false);
  const [shippingPrice, setShippingPrice] = useState(0);
  const [addressId, setAddressId] = useState(null);
  const [shippingPriceValue, setShippingPriceValue] = useState(0);

  const billingFormRef = useRef(null);
  const shippingFormRef = useRef(null);

  // let userLogin = localStorage.getItem("userData");

  const getShippingPrice = (value) => {
    if (!value || value.length === 0) return 0;
    // const maxValue = Math.max(...value.map((acc) => acc.shipping_cost || 0));

    const totalShippingCost = value.reduce((sum, acc) => {
      const cost = parseFloat(acc.shipping_cost) || 0;
      const qty = parseInt(acc.quantity) || 1;
      return sum + cost * qty;
    }, 0);

    if (userLogin?.isFirstOrder) return 0;
    const returnValue = Number(totalShippingCost.toFixed(2));
    setShippingPriceValue(returnValue);
    return returnValue;
  };



  // useEffect(() => {
  //   const div_section = document.querySelector(".contact-us");
  //   const first_section = document.querySelector(".first-section");
  // });

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });

    if (userLogin) {
      setLoaderCheck(true);
      axiosPrivate
        .get("coupons")
        .then((res) => {
          setLoaderCheck(false);
          setCouponList(res?.data?.data);
        })
        .catch((err) => {
          setLoaderCheck(false);
          // showErrorToast(
          //   err?.response?.data?.message || err?.response?.data?.errors[0]?.msg
          // );
        });
    } else {
      // User is not logged in, fetch global active coupons
      setLoaderCheck(true);
      axiosPrivate
        .get("coupons", {
          params: {
            coupon_type: "Global",
            is_active: "Active",
          },
        })
        .then((res) => {
          setLoaderCheck(false);
          const activeGlobalCoupons = res?.data?.data?.filter(
            (coupon) =>
              coupon.is_active === "Active" && coupon.coupon_type === "Global"
          );
          setCouponList(activeGlobalCoupons);
        })
        .catch((err) => {
          setLoaderCheck(false);
          showErrorToast(
            err?.response?.data?.message || err?.response?.data?.errors[0]?.msg
          );
        });
    }
  }, [userLogin]);

  // form1 submit

  const submitForm = () => {
    if (addresses?.filter((res) => res.bill_type === "billing").length <= 0) {
      setErrorMsg("*Please Fill Billing Address!");
      errorToast("Please Fill Billing Address!");
      return;
    }
    if (!billingAddress?.id) {
      setErrorMsg("*Please Select Billing Address!");
      errorToast("Please Select Billing Address!");
      return;
    }
    if (addresses?.filter((res) => res.bill_type === "shipping").length <= 0 && differentAddress) {
      setErrorMsg("*Please Fill Shipping Address!");
      errorToast("Please Fill Shipping Address!");
      return;
    }
    if (differentAddress && !shippingDelivery?.id) {
      setErrorMsg("*Please Select Shipping Address!");
      errorToast("Please Select Shipping Address!");
      return;
    }
    if (Object.keys(billingAddress)?.length > 0) {
      if (showPaymentMethod) {
        let orderObject = {
          payment_mode: showPaymentMethod,
          user_id: userLogin?.userId,
          bill_address_id: billingAddress?.id,
          bill_name: billingAddress?.name,
          bill_mobile: billingAddress?.mobile,
          bill_customer_uniqueID: billingAddress?.customer_unique_id,
          bill_address: billingAddress?.address,
          bill_email: billingAddress?.email,
          bill_pincode: billingAddress?.pincode,
          bill_state: billingAddress?.state,
          bill_city: billingAddress?.city,
          bill_country: billingAddress?.country,
          ship_address_id: shippingDelivery?.id || "",
          ship_email: shippingDelivery?.email || billingAddress?.email,
          ship_name: shippingDelivery?.name || billingAddress?.name,
          ship_mobile: shippingDelivery?.mobile || billingAddress?.mobile,
          ship_address: shippingDelivery?.address || billingAddress?.address,
          ship_pincode: shippingDelivery?.pincode || billingAddress?.pincode,
          ship_state: shippingDelivery?.state || billingAddress?.state,
          ship_city: shippingDelivery?.city || billingAddress?.city,
          same_as_address: differentAddress ? "0" : "1",
          ship_country: shippingDelivery?.country || billingAddress?.country,
          ship_customer_uniqueID: shippingDelivery?.customer_unique_id || billingAddress?.customer_unique_id,
          order_status: "pending",
          coupon_id: inputCouponValue,
          gst_no: billingAddress?.gst,
          // shipping_amount: shippingCharge,
          shipping_amount: shippingPrice,
          discount_percent: discountPercent,
        };

        if (seletedCouponId) {
          orderObject.coupon_id = seletedCouponId;
        }
        setLoaderCheck(true);

        axiosPrivate
          .post("orders/create", orderObject)
          .then((res) => {
            const payuFormHtml = res.data;

            if (payuFormHtml) {
              const div = document.createElement("div");
              div.innerHTML = payuFormHtml;
              const form = div.querySelector("form");

              if (form) {
                document.body.appendChild(form);
                form.submit();
              }
            }

            setLoaderCheck(false);
            // successToast("Order Placed Successfully!");
          })
          .catch((err) => {
            setLoaderCheck(false);
            showErrorToast(
              err?.response?.data?.message ||
              err?.response?.data?.errors[0]?.msg ||
              err?.response?.data?.errors?.msg
            );
          });
      } else {
        errorToast("*Please Select Payment Method!");
        setErrorMsg("*Please Select Payment Method!");
      }
    } else {
      setErrorMsg("*Please Select Billing Address!");
      errorToast("Please Select Billing Address!");
    }
  };


  useEffect(() => {
    // if (userLogin && action === "login" && !firstOrder) {
    if (userLogin) {
      setLoaderCheck(true);
      axiosPrivate
        .get("carts/get")
        .then((res) => {
          setLoaderCheck(false);
          setCheckoutProduct(res?.data?.data);
          getUserAddresses();
        })
        .catch((error) => {
          setLoaderCheck(false);
          if (error?.response?.data?.data?.length == 0) {
            navigate("/cart");
          }
          // showErrorToast(
          //   error?.response?.data?.message ||
          //     error?.response?.data?.errors[0]?.msg
          // );
        });
    } else {
      // debugger;
      getUserAddresses();

      // if (action === "login") {
      //   getUserAddresses();
      // }
      let cart_items = JSON.parse(localStorage.getItem("cart_items"));
      setCheckoutProduct(cart_items);
    }
  }, []);


  const getUserAddresses = () => {
    setLoaderCheck(true);
    axiosPrivate
      .get("user-addresses/get")
      .then((res) => {
        setLoaderCheck(false);
        setAddresses(res.data.data);
      })
      .catch((err) => {
        setLoaderCheck(false);
      });
  };

  useEffect(() => {
    let total = 0;
    setCartCount(checkoutProduct?.length || 0);

    if (checkoutProduct?.length > 0) {
      checkoutProduct?.forEach((response, index) => {
        total +=
          (response?.regular_price ?? response?.rate) * response?.quantity;
        if (index == checkoutProduct?.length - 1) {
          total = total + shippingCharge;
        }
      });
      setCheckoutTotal(total?.toFixed(2));
    }
    const shippingPrice = getShippingPrice(checkoutProduct);
    const isFreeShippingAvailable =
      userLogin?.freeShippingAt !== undefined &&
      total > userLogin?.freeShippingAt;
    setShippingPrice(isFreeShippingAvailable ? 0 : shippingPrice);
    const applicableDiscount = userLogin?.discounts?.find(
      (d) => total >= d.amount
    );
    const discountPercent = applicableDiscount
      ? applicableDiscount?.discount
      : 0;

    setDiscountPercent(discountPercent);
  }, [checkoutProduct]);


  function selectShippingAddress(res) {
    setShippingDelivery(res);
  }

  function selectBillingAddress(res) {
    setBillingAddress(res);
  }

  const closeDiv = (data, type) => {
    setNewAddress(false);
    setVisible(false);
    getUserAddresses();
    if (data && typeof data === 'object') {
      const addressType = type || data.bill_type;
      if (addressType === 'billing') {
        selectBillingAddress(data);
        setAddressId(data.id);
      } else if (addressType === 'shipping') {
        selectShippingAddress(data);
      }
    }
  };


  useEffect(() => {
    calculateCouponValue();
  }, [couponValue]);

  const calculateCouponValue = () => {
    if (couponValue) {
      setInputCouponValue(couponValue);
    }
    if (couponValue || inputCouponValue) {
      setLoaderCheck(true);
      axiosPrivate
        .get(`checkout/${userLogin?.userId}/${couponValue ?? inputCouponValue}`)
        .then((res) => {
          setLoaderCheck(false);
          // if (res?.data?.data?.cart_min_amount <= subTotal) {
          successToast("Coupon Applied Successfully!");
          let discount =
            res?.data?.data?.total_bill_amount -
            res?.data?.data?.total_pay_amount;
          setDiscountValue(discount?.toFixed(2));
          let totalvalue =
            res?.data?.data?.total_bill_amount - discount + shippingCharge;
          setCheckoutTotal(totalvalue?.toFixed(2));
          setSelectedCouponId(res?.data?.data?.coupon_id);
          setRemoveCoupon(true);
        })
        .catch((err) => {
          setCouponName("");
          setLoaderCheck(false);
          setSelectedCouponId("");
          setCouponValue(null);
          setInputCouponValue("");
          showErrorToast(
            err?.response?.data?.message || err?.response?.data?.errors[0]?.msg
          );
        });
    }
  };


  const [showNewBillingForm, setShowNewBillingForm] = useState(false);
  const [showNewShippingForm, setShowNewShippingForm] = useState(false);

  useEffect(() => {
    if (showNewBillingForm && billingFormRef.current) {
      billingFormRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [showNewBillingForm]);

  useEffect(() => {
    if (showNewShippingForm && shippingFormRef.current) {
      shippingFormRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [showNewShippingForm]);

  return (
    <>
      <>
        <Dialog
          header="Address Form"
          visible={visible}
          className={styles.addressForm}
          onHide={() => setVisible(false)}
        >
          <UserAddressForm getData={userData} sendData={closeDiv} />
        </Dialog>
      </>
      <div className={styles.checkout}>
        <section className={styles.leftSection}>
          <div className={styles.addressSelection}>
            {/* Billing Address Section */}
            <div className={styles.sectionCard}>
              <div className={styles.sectionHeader}>
                <h3 className={styles.sectionTitle}>
                  {addresses?.length > 0 ? "Select Billing Address" : "Add Billing Address"}
                </h3>
                {/* Add New Billing Address Button */}
                {addresses?.length > 0 && (
                  <div
                    className={styles.addNewButton}
                    onClick={() => setShowNewBillingForm(!showNewBillingForm)}
                  >
                    <span className={styles.addIcon}>+</span>
                    <span>Add New Billing Address</span>
                  </div>
                )}
              </div>

              {addresses?.length > 0 && (
                <div className={styles.addressGrid}>
                  {addresses
                    ?.filter((res) => res.bill_type === "billing")
                    .map((res) => (
                      <div
                        key={res.id}
                        className={styles.addressCard}
                        onClick={() => {
                          selectBillingAddress(res);
                          setAddressId(res.id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <label className={styles.addressRadio}>
                          <input
                            type="radio"
                            name="billingAddress"
                            checked={addressId === res.id}
                            onChange={() => {
                              selectBillingAddress(res);
                              setAddressId(res.id);
                            }}
                          />
                          <div className={styles.radioCustom}></div>
                        </label>

                        <div className={styles.addressInfo}>
                          <h4 className={styles.addressName}>{res?.name}</h4>
                          <p className={styles.addressText}>
                            {res?.address} {res?.landmark} {res?.city} {res?.state} {res?.pincode}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {/* New Billing Address Form */}
              {(showNewBillingForm || addresses?.length === 0) && (
                <div className={styles.formContainer} ref={billingFormRef}>
                  <UserAddressForm
                    billtype={"billing"}
                    getData={userData}
                    sendData={(data) => {
                      setShowNewBillingForm(false);
                      closeDiv(data, "billing");
                    }}
                    addressType="billing"
                  />
                </div>
              )}
            </div>

            {/* Delivery Options */}
            <div className={styles.sectionCard}>
              <div className={styles.formHeader}>
                <h3 className={styles.formTitle}>Delivery Options</h3>
              </div>

              <div className={styles.deliveryOptions}>
                <label className={styles.optionCard}>
                  <input
                    type="radio"
                    name="delivery_option"
                    checked={!differentAddress}
                    onChange={() => setDifferentAddress(false)}
                  />
                  <div className={styles.optionContent}>
                    <div>
                      <div className={styles.optionTitle}>Same as billing address</div>
                      <div className={styles.optionDescription}>Use my billing address for delivery</div>
                    </div>
                  </div>
                </label>

                <label className={styles.optionCard}>
                  <input
                    type="radio"
                    name="delivery_option"
                    checked={differentAddress}
                    onChange={() => setDifferentAddress(true)}
                  />
                  <div className={styles.optionContent}>
                    <div>
                      <div className={styles.optionTitle}>Different shipping address</div>
                      <div className={styles.optionDescription}>Ship to a different location</div>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            {/* Shipping Address Section - Only show when different address is selected */}
            {differentAddress && (
              <div className={styles.sectionCard}>
                <div className={styles.sectionHeader}>
                  <h3 className={styles.sectionTitle}>
                    {addresses?.filter((res) => res.bill_type === "shipping").length > 0
                      ? "Select Shipping Address"
                      : "Add Shipping Address"}
                  </h3>
                  {/* Add New Shipping Address Button */}
                  {addresses?.filter((res) => res.bill_type === "shipping").length > 0 && (
                    <div
                      className={styles.addNewButton}
                      onClick={() => setShowNewShippingForm(!showNewShippingForm)}
                    >
                      <span className={styles.addIcon}>+</span>
                      <span>Add New Shipping Address</span>
                    </div>
                  )}
                </div>

                {addresses?.filter((res) => res.bill_type === "shipping").length > 0 && (
                  <div className={styles.addressGrid}>
                    {addresses
                      ?.filter((res) => res.bill_type === "shipping")
                      .map((res) => (
                        <div
                          key={res.id}
                          className={styles.addressCard}
                          onClick={() => selectShippingAddress(res)}
                          style={{ cursor: "pointer" }}
                        >
                          <label className={styles.addressRadio}>
                            <input
                              type="radio"
                              name="shippingAddress"
                              checked={shippingDelivery?.id === res.id}
                              onChange={() => selectShippingAddress(res)}
                            />
                            <div className={styles.radioCustom}></div>
                          </label>

                          <div className={styles.addressInfo}>
                            <h4 className={styles.addressName}>{res?.name}</h4>
                            <p className={styles.addressText}>
                              {res?.address} {res?.landmark} {res?.city} {res?.state} {res?.pincode}
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

                {/* New Shipping Address Form */}
                {(showNewShippingForm || addresses?.filter((res) => res.bill_type === "shipping").length === 0) && (
                  <div className={styles.formContainer} ref={shippingFormRef}>
                    <UserAddressForm
                      billtype={"shipping"}
                      getData={userData}
                      sendData={(data) => {
                        setShowNewShippingForm(false);
                        closeDiv(data, "shipping");
                      }}
                      addressType="shipping"
                    />
                  </div>
                )}
              </div>
            )}

            {/* Additional Actions */}
            {addresses.length > 0 && (
              <div className={styles.actionSection}>
                <div className={styles.actionCard}>
                  <div
                    className={styles.actionHeader}
                    onClick={() => navigate("/user-dashboard")}
                  >
                    <div className={styles.actionTitle}>
                      <div style={{ fontSize: "24px", fontWeight: "600" }}>View Order History</div>
                    </div>
                    <FaAngleRight />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <section className={styles.verticalLine}></section>
        <section className={styles.rightSection}>
          <div className={styles.orderSummary}>
            <h3 className={styles.summaryTitle}>Order Summary</h3>

            <div className={styles.orderItems}>
              {checkoutProduct?.length > 0 && checkoutProduct?.map((res, index) => (
                <div key={index} className={styles.orderItem}>
                  <div className={styles.itemImage}>
                    <img
                      src={process.env.REACT_APP_COMMON_FILE_URL + `product-variants/` + res?.variant_iamge?.[0]?.image}
                      alt={res.order}
                      loading="lazy"
                    />
                    <span className={styles.itemQuantity}>{res?.quantity}</span>
                  </div>
                  <div className={styles.itemDetails}>
                    <div className={styles.itemName}>{res?.name ?? res?.product_name}</div>
                    <div className={styles.itemPrice}>
                      <img src="/checkout/currency.png" alt="currency" loading="lazy" />
                      {res?.quantity * (res?.regular_price ?? res?.rate)}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.summaryBreakdown}>
              <div className={styles.summaryRow}>
                <span>Sub Total</span>
                <span>
                  <img src="/checkout/currency.png" alt="currency" loading="lazy" />{" "}
                  {Number(checkoutTotal || 0).toFixed(2)}
                </span>

              </div>
              <div className={styles.summaryRow}>
                <span>
                  Shipping {userLogin?.isFirstOrder ? "(First order)" : ""}
                  {shippingPrice <= 0 && !userLogin?.isFirstOrder && shippingPriceValue
                    ? `(order above 499)`
                    : ""}
                </span>
                <span className={styles.price}>
                  {shippingPrice > 0 ? (
                    <>
                      <img src="/checkout/currency.png" alt="currency" loading="lazy" />
                      {shippingPrice}
                    </>
                  ) : (
                    "Free"
                  )}
                </span>
              </div>

              {discountPercent ? (
                <div className={styles.summaryRow}>
                  <span>Discount {discountPercent}% (order above Rs. 799)</span>
                  <span>
                    - <img src="/checkout/currency.png" alt="currency" loading="lazy" />{" "}
                    {(
                      (Number(checkoutTotal || 0) + Number(shippingPrice || 0)) *
                      (Number(discountPercent || 0) / 100)
                    ).toFixed(2)}
                  </span>
                </div>
              ) : null}


              <div className={styles.summaryTotal}>
                <span>Total</span>
                <span className={styles.totalPrice}>
                  <img src="/checkout/currency.png" alt="currency" loading="lazy" />
                  {(
                    (Number(checkoutTotal || 0) + Number(shippingPrice || 0)) *
                    (1 - (Number(discountPercent || 0) / 100))
                  ).toFixed(2)}
                </span>
              </div>

            </div>

            <div className={styles.paymentSection}>
              <button className={styles.payButton} onClick={submitForm}>
                Proceed to Payment
              </button>
              <div className={styles.securePayment}>
                <BiSolidLock className={styles.secureIcon} />
                Payments are processed securely
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default React.memo(Checkout); // Memoize the Checkout;
